import { useAuthStore } from '~/stores/auth';
import { checkoutPurchaseUrl } from '~/utils/cross-app-urls';

export default defineNuxtPlugin(() => {
    const router = useRouter();
    const authStore = useAuthStore();

    // Watch for route changes to detect a promo code in the URL. A promo means the visitor
    // intends to buy, so send them straight to the checkout select-plan modal with the promo
    // carried through (auto-applied there).
    router.afterEach((to) => {
        const promoCode = to.query.promo as string | undefined;
        if (!promoCode) return;

        // Employer purchase restriction: employees whose employer disabled Pro purchases must not
        // be funnelled into checkout (the purchase is rejected server-side anyway). Leave them put.
        if (authStore.user?.employer?.can_purchase_pro === false) return;

        // Everything except `promo`, kept for both the checkout return_to and the local history
        // rewrite below, so context carried on other query params (e.g. `person` for impersonation)
        // survives the checkout round-trip.
        const returnQuery = { ...to.query };
        delete returnQuery.promo;

        const returnParams = new URLSearchParams();
        for (const [key, value] of Object.entries(returnQuery)) {
            if (value == null) continue;
            if (Array.isArray(value)) {
                value.forEach((v) => v != null && returnParams.append(key, String(v)));
            } else {
                returnParams.append(key, String(value));
            }
        }
        const query = returnParams.toString();
        const returnTo = query ? `${to.path}?${query}` : to.path;

        // Replace the ?promo history entry with the promo-stripped URL BEFORE leaving for checkout,
        // so pressing Back from checkout lands on a clean URL instead of immediately re-triggering
        // this redirect (a Back-button trap). Mirrors the ?upgrade/?purchase strip on the dashboard.
        // The replaced navigation carries no promo, so this afterEach no-ops on it. `.finally` runs
        // the external redirect whether the replace resolves or is deduped/aborted.
        router
            .replace({ path: to.path, query: returnQuery })
            .finally(() => {
                window.location.href = checkoutPurchaseUrl(returnTo, { promo: promoCode });
            });
    });
});
